export default (min, max) => {
    return parseInt((Math.random() * ((max - min) + 1)) + min);
};
